import { render, staticRenderFns } from "./OrgExternalDonorsProvider.vue?vue&type=template&id=69a12934&"
import script from "./OrgExternalDonorsProvider.vue?vue&type=script&lang=js&"
export * from "./OrgExternalDonorsProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports